var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7497 11.7917H13.7572M15.8324 3.33398H5.16569C4.23227 3.33398 3.76556 3.33398 3.40904 3.51564C3.09544 3.67543 2.84047 3.9304 2.68068 4.244C2.49902 4.60052 2.49902 5.06723 2.49902 6.00065V14.0007C2.49902 14.9341 2.49902 15.4008 2.68068 15.7573C2.84047 16.0709 3.09544 16.3259 3.40904 16.4857C3.76556 16.6673 4.23227 16.6673 5.16569 16.6673H14.8324C15.7658 16.6673 16.2325 16.6673 16.589 16.4857C16.9026 16.3259 17.1576 16.0709 17.3174 15.7573C17.499 15.4008 17.499 14.9341 17.499 14.0007V9.33398C17.499 8.40056 17.499 7.93385 17.3174 7.57733C17.1576 7.26373 16.9026 7.00876 16.589 6.84897C16.2325 6.66732 15.7658 6.66732 14.8324 6.66732H5.83236M14.1247 11.7917C14.1247 11.9988 13.9568 12.1667 13.7497 12.1667C13.5426 12.1667 13.3747 11.9988 13.3747 11.7917C13.3747 11.5846 13.5426 11.4167 13.7497 11.4167C13.9568 11.4167 14.1247 11.5846 14.1247 11.7917Z",
    stroke: "#4ed5d2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.6f6c438f5b15167039a1ecd7098638d1.svg";
export { ForwardRef as ReactComponent };